import Components from "./components";
import Header from "./components/header";

/**
 * Calls a supplied function once
 * document has loaded.
 *
 * @param  {CallableFunction} onReady
 * @return {void}
 */
const domReady = (onReady) => {
	if (document.readyState !== "loading") {
		// Document is already ready, call the callback directly
		onReady();
	} else if (document.addEventListener) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener("DOMContentLoaded", onReady);
	} else {
		// Old IE browsers
		document.attachEvent("onreadystatechange", function () {
			if (document.readyState === "complete") {
				onReady();
			}
		});
	}
};

const App = {
	init() {
		// console.log('+++++++++ STARTING APP +++++++++')
		console.log(
			"\n\n%cCreated with %c♥ %cby Nelios%c\n\n",
			"border-top-left-radius: 10px;border-bottom-left-radius: 10px;padding: 20px 0px 20px 20px;color: #fff;background: #7cc142;",
			"padding: 20px 0px 20px 0px;background: #7cc142;color: red;",
			"border-top-right-radius: 10px;border-bottom-right-radius: 10px;padding: 20px 20px 20px 0px;background: #7cc142;color: #fff;",
			"background: white;"
		);

		const header = new Header();
		const scrollBarElement = document.querySelector("[data-scrollbar]");

		let scrollBar;
		let scrollTimeout;

		const isDesktop = (theWidth = 768) => {
			if (isNaN(theWidth)) return false;
			return theWidth <= window.innerWidth;
		};

		const MobileScrollInit = () => {
			let observerOptions = {
				// threshold: [0, 1]
			};

			// Observer for fade-in-me effect
			const observerEffectFade = new IntersectionObserver((entries) => {
				entries.map((entry, index) => {
					if (entry.isIntersecting) {
						setTimeout(() => {
							entry.target.classList.add("is-in-view");
							observerEffectFade.unobserve(entry.target);
						}, 250 * index);
					}
				});
			}, observerOptions);

			document
				.querySelectorAll(".fade-in-me")
				.forEach((observable) => observerEffectFade.observe(observable));
		};

		const onWindowResize = (ev) => {
			MobileScrollInit();
		};

		window.addEventListener("resize", (ev) => {
			onWindowResize();
		});

		window.dispatchEvent(new Event("resize"));

		const removeActives = () => {
			document.querySelectorAll( '.card-package' ).forEach( el => {
				el.classList.remove('active-package');
			})
		}

		if (document.body.classList.contains("page-template-commerce")) {

			if (document.getElementById("custom-pricing-open") && document.getElementById("custom-pricing-form")) {
				document.getElementById("custom-pricing-open").addEventListener("click", (e) => {
					e.preventDefault();
					removeActives();
					document.querySelector('#commerce .custom-card').classList.add('active-package')
					document.getElementById("group-pricing-form").classList.add("hidden");
					document.getElementById("single-pricing-form").classList.add("hidden");
					document.getElementById("custom-pricing-form").classList.remove("hidden");
					document.getElementById("custom-pricing-formm").scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
				});
			}

			if (document.getElementById("single-pricing-open") && document.getElementById("single-pricing-form")) {
				document.getElementById("single-pricing-open").addEventListener("click", (e) => {
					e.preventDefault();
					removeActives();
					document.querySelector('#commerce .single-card').classList.add('active-package')
					document.getElementById("group-pricing-form").classList.add("hidden");
					document.getElementById("single-pricing-form").classList.remove("hidden");
					document.getElementById("single-pricing-form").scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
					document.getElementById("custom-pricing-form").classList.add("hidden");
				});
			}

			if (document.getElementById("group-pricing-open") && document.getElementById("group-pricing-form")) {
				document.getElementById("group-pricing-open").addEventListener("click", (e) => {
					e.preventDefault();
					removeActives();
					document.querySelector('#commerce .group-card').classList.add('active-package')
					document.getElementById("group-pricing-form").classList.remove("hidden");
					document.getElementById("group-pricing-form").scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
					document.getElementById("single-pricing-form").classList.add("hidden");
					document.getElementById("custom-pricing-form").classList.add("hidden");
				});
			}

			let hotelsField = document.getElementById("hotels-field");
			let hotelsLabel = document.getElementById("hotels-count");
			let hotelsPrice = document.getElementById("base-price-group");
			let hotelsPriceVAT = document.getElementById("base-price-group-vat");
			let hotelsPriceTotal = document.getElementById("total-amount-group");
			let basePrice = document.getElementById("base-price-hotel") && document.getElementById("base-price-hotel").innerHTML;
			let basePriceBase = document.getElementById("base-price-base") && document.getElementById("base-price-base").innerText;
			if (! basePrice || ! basePriceBase) return;
			if (hotelsField) {
				hotelsField.addEventListener("change", function () {

					calcDiscount();

				});
			}

			document.querySelector(".single-payment").addEventListener("click", function (e) {
					// document.querySelector('.loader').classList.remove('hidden');
					let action = this.dataset.action;
					let nonce = this.dataset.nonce;
					e.preventDefault();

					let name = document.querySelector(
						'#single-pricing-form input[name="fullname"]'
					).value;
					let email = document.querySelector(
						'#single-pricing-form input[name="email"]'
					).value;
					let phone = document.querySelector(
						'#single-pricing-form input[name="tel"]'
					).value;
					let hotel_name = document.querySelector(
						'#single-pricing-form input[name="hotel"]'
					).value;
					let domain = document.querySelector(
						'#single-pricing-form input[name="domain"]'
					).value;
					let acceptance = document.querySelector(
						'#single-pricing-form input[name="acceptance"]'
					).value;
					let promo = document.querySelector(
						'#single-pricing-form input[name="promo"]'
					).value;
					let company = document.querySelector(
						'#single-pricing-form input[name="company"]'
					).value;
					let vat = document.querySelector(
						'#single-pricing-form input[name="vat"]'
					).value;
					let tax = document.querySelector(
						'#single-pricing-form input[name="tax"]'
					).value;
					let address = document.querySelector(
						'#single-pricing-form input[name="address"]'
					).value;
					let info = document.querySelector(
						'#single-pricing-form textarea[name="info"]'
					).value;
					let pageID = document.querySelector(
						'#single-pricing-form input[name="pageID"]'
					).value;

					if ( ! name || ! email || ! phone || ! hotel_name || ! domain || ! acceptance || ! company || ! vat || ! tax || ! address ) {
						if ( ! name  ) {
							document.querySelector('#single-pricing-form input[name="fullname"]').classList.add('border-nelios-red-100');
						}
						if ( ! email  ) {
							document.querySelector('#single-pricing-form input[name="email"]').classList.add('border-nelios-red-100');
						}
						if ( ! phone  ) {
							document.querySelector('#single-pricing-form input[name="tel"]').classList.add('border-nelios-red-100');
						}
						if ( ! hotel_name  ) {
							document.querySelector('#single-pricing-form input[name="hotel"]').classList.add('border-nelios-red-100');
						}
						if ( ! domain  ) {
							document.querySelector('#single-pricing-form input[name="domain"]').classList.add('border-nelios-red-100');
						}
						if ( ! acceptance  ) {
							document.querySelector('#single-pricing-form input[name="acceptance"]').classList.add('border-nelios-red-100');
						}
						if ( ! company  ) {
							document.querySelector('#single-pricing-form input[name="company"]').classList.add('border-nelios-red-100');
						}
						if ( ! vat  ) {
							document.querySelector('#single-pricing-form input[name="vat"]').classList.add('border-nelios-red-100');
						}
						if ( ! tax  ) {
							document.querySelector('#single-pricing-form input[name="tax"]').classList.add('border-nelios-red-100');
						}
						if ( ! address  ) {
							document.querySelector('#single-pricing-form input[name="address"]').classList.add('border-nelios-red-100');
						}
						// if ( ! info  ) {
						// 	document.querySelector('#single-pricing-form textarea[name="info"]').classList.add('border-nelios-red-100');
						// }
						return;
					}

					const request = new XMLHttpRequest();

					request.open("POST", THEME_OBJ.ajaxURL, true);
					request.setRequestHeader(
						"Content-Type",
						"application/x-www-form-urlencoded;"
					);
					request.onload = function () {
						if (this.status >= 200 && this.status < 400) {
							// If successful
							let response = this.response;
						//	console.log(response);
							let response_json = JSON.parse(response);
							console.log(response_json);
							if (response_json.success === true) {
								window.location.href=response_json.payment_link;
								// console.log(response_json.payment_link);
							}
						} else {
							// If fail
							console.log(this.response);
						}
					};
					request.onerror = function () {
						// Connection error
					};
					let data = `action=${action}&nonce=${nonce}&promo=${promo}&address=${address}&info=${info}&tax=${tax}&vat=${vat}&company=${company}&name=${name}&email=${email}&phone=${phone}&hotel_name=${hotel_name}&domain=${domain}&form_type=single&pageID=${pageID}`;
					request.send(data);
				});

			document.querySelector(".group-payment").addEventListener("click", function (e) {
					// document.querySelector('.loader').classList.remove('hidden');
					let action = this.dataset.action;
					let nonce = this.dataset.nonce;
					e.preventDefault();
					let name = document.querySelector(
						'#group-pricing-form input[name="fullname"]'
					).value;
					let email = document.querySelector(
						'#group-pricing-form input[name="email"]'
					).value;
					let phone = document.querySelector(
						'#group-pricing-form input[name="tel"]'
					).value;
					let hotel_name = document.querySelector(
						'#group-pricing-form input[name="hotel"]'
					).value;
					let domain = document.querySelector(
						'#group-pricing-form input[name="domain"]'
					).value;
					let hotels = document.querySelector(
						'#group-pricing-form input[name="hotels"]'
					).value;
					let promo = document.querySelector(
						'#group-pricing-form input[name="promo"]'
					).value;
					let acceptance = document.querySelector(
						'#group-pricing-form input[name="acceptance"]'
					).value;
					let company = document.querySelector(
						'#group-pricing-form input[name="company"]'
					).value;
					let vat = document.querySelector(
						'#group-pricing-form input[name="vat"]'
					).value;
					let tax = document.querySelector(
						'#group-pricing-form input[name="tax"]'
					).value;
					let address = document.querySelector(
						'#group-pricing-form input[name="address"]'
					).value;
					let info = document.querySelector(
						'#group-pricing-form textarea[name="info"]'
					).value;

					if ( ! name || ! email || ! phone || ! hotel_name || ! domain || ! acceptance || ! company || ! vat || ! tax || ! address ) {
						if ( ! name  ) {
							document.querySelector('#group-pricing-form input[name="fullname"]').classList.add('border-nelios-red-100');
						}
						if ( ! email  ) {
							document.querySelector('#group-pricing-form input[name="email"]').classList.add('border-nelios-red-100');
						}
						if ( ! phone  ) {
							document.querySelector('#group-pricing-form input[name="tel"]').classList.add('border-nelios-red-100');
						}
						if ( ! hotel_name  ) {
							document.querySelector('#group-pricing-form input[name="hotel"]').classList.add('border-nelios-red-100');
						}
						if ( ! domain  ) {
							document.querySelector('#group-pricing-form input[name="domain"]').classList.add('border-nelios-red-100');
						}
						if ( ! company  ) {
							document.querySelector('#group-pricing-form input[name="company"]').classList.add('border-nelios-red-100');
						}
						if ( ! vat  ) {
							document.querySelector('#group-pricing-form input[name="vat"]').classList.add('border-nelios-red-100');
						}
						if ( ! tax  ) {
							document.querySelector('#group-pricing-form input[name="tax"]').classList.add('border-nelios-red-100');
						}
						if ( ! address  ) {
							document.querySelector('#group-pricing-form input[name="address"]').classList.add('border-nelios-red-100');
						}
						// if ( ! info  ) {
						// 	document.querySelector('#group-pricing-form textarea[name="info"]').classList.add('border-nelios-red-100');
						// }
						return;
					}

					const request = new XMLHttpRequest();

					request.open("POST", THEME_OBJ.ajaxURL, true);
					request.setRequestHeader(
						"Content-Type",
						"application/x-www-form-urlencoded;"
					);
					request.onload = function () {
						if (this.status >= 200 && this.status < 400) {
							// If successful
							let response = this.response;
							//	console.log(response);
							let response_json = JSON.parse(response);
							console.log(response_json);
							if (response_json.success === true) {
								window.location.href=response_json.payment_link;
								// console.log(response_json.payment_link);
							}
						} else {
							// If fail
							console.log(this.response);
						}
					};
					request.onerror = function () {
						// Connection error
					};
					let data = `action=${action}&nonce=${nonce}&name=${name}&email=${email}&phone=${phone}&hotel_name=${hotel_name}&domain=${domain}&form_type=group&hotels=${hotels}&promo=${promo}&company=${company}&vat=${vat}&tax=${tax}&address=${address}&info=${info}`;
					request.send(data);
					//
				});

			document.querySelector('#single-pricing-form input[name="promo"]').addEventListener( 'keyup', e => {
				let action = e.target.dataset.action;
				let nonce = e.target.dataset.nonce;
				e.preventDefault();
				console.log(e.target.value)
				const request = new XMLHttpRequest();

				request.open("POST", THEME_OBJ.ajaxURL, true);
				request.setRequestHeader(
					"Content-Type",
					"application/x-www-form-urlencoded;"
				);
				request.onload = function () {
					if (this.status >= 200 && this.status < 400) {
						// If successful
						let response = this.response;
						//	console.log(response);
						let response_json = JSON.parse(response);
						if (response_json.success === true) {
							console.log(response_json.msg);
							document.querySelector('#single-pricing-form input[name="promo"]').classList.add('border-nelios-green-200');
							document.getElementById('promo-div').classList.remove('hidden');
							let basePrice = document.getElementById("single-base-price");
							let total = document.getElementById("single-total-price");
							document.getElementById('single-base-price-vat').innerHTML = total.innerHTML = ( ( parseFloat( basePrice.innerHTML ) - parseFloat( basePrice.innerHTML ) * 0.2 ) * 0.24 ).toFixed(2);
							if (basePrice) {
								total.innerHTML = ( parseFloat( basePrice.innerHTML ) - parseFloat( basePrice.innerHTML ) * 0.2 + ( parseFloat( basePrice.innerHTML ) - parseFloat( basePrice.innerHTML ) * 0.2 ) * 0.24 ).toFixed(2);
								console.log(total.innerHTML)
							}
						} else {
							document.querySelector('#single-pricing-form input[name="promo"]').classList.add('border-nelios-red-100');
							let basePrice = document.getElementById("single-base-price");
							let total = document.getElementById("single-total-price");
							if (basePrice) {
								total.innerHTML = parseFloat( basePrice.innerHTML ) + parseFloat( basePrice.innerHTML ) * 0.24;
							}
							document.getElementById('promo-div').classList.add('hidden');
						}
					} else {
						// If fail
						console.log(this.error);
						document.getElementById('promo-div').classList.add('hidden');
					}
				};
				request.onerror = function () {
					console.log('connection error')
				};
				let data = `action=${action}&nonce=${nonce}&promo=${e.target.value}`;
				request.send(data);
			})

			const calcDiscount = () => {
				if (document.getElementById('promo-div-group').dataset.discount === 'true') {
					let hotelsPrice = parseInt( hotelsField.value ) * parseFloat( basePrice );
					let base = parseFloat( basePriceBase );
					document.getElementById("group-promo-price").innerHTML = ( hotelsPrice * 0.2 + base * 0.2 ).toFixed(2);
					let discPrice = hotelsPrice * 0.2 + base * 0.2;
					let hotelsPriceTotal = document.getElementById("total-amount-group");
					if (hotelsPriceTotal) {
						let totalPrice = parseFloat(basePrice) * parseInt(this.value);
						hotelsPriceTotal.innerHTML = ( parseFloat(basePriceBase) + parseFloat(totalPrice) + ( parseFloat(basePriceBase) + parseFloat(totalPrice) ) * 0.24 ).toFixed(2);
					}
				}
				else {
					document.getElementById("group-promo-price").innerHTML = '0';
				}

				hotelsLabel.innerHTML = hotelsField.value;

				let constPrice = parseFloat(basePriceBase);

				console.log('constPrice');
				console.log(constPrice);

				let totalPriceHotels = parseFloat(basePrice) * parseInt(hotelsField.value);
				hotelsPrice.innerHTML = parseFloat(basePriceBase) + parseFloat(totalPriceHotels);

				document.getElementById("base-price-hotel").innerHTML = totalPriceHotels;

				console.log('totalPriceHotels');
				console.log(totalPriceHotels);

				let discount = parseFloat(document.getElementById("group-promo-price").innerHTML).toFixed(2);

				let vatPrice = ( ( parseFloat(basePriceBase) + parseFloat(totalPriceHotels) - parseFloat(discount) ) * 0.24 ).toFixed(2);
				hotelsPriceVAT.innerHTML = vatPrice;

				console.log('vatPrice');
				console.log(vatPrice);

				let finalPrice = ( constPrice + parseFloat(totalPriceHotels) + parseFloat(vatPrice) - parseFloat(discount) ).toFixed(2);

				hotelsPriceTotal.innerHTML =  finalPrice;

			}

			document.querySelector('#group-pricing-form input[name="promo"]').addEventListener( 'keyup', e => {
				let action = e.target.dataset.action;
				let nonce = e.target.dataset.nonce;
				e.preventDefault();
console.log(e.target.value)
				const request = new XMLHttpRequest();

				request.open("POST", THEME_OBJ.ajaxURL, true);
				request.setRequestHeader(
					"Content-Type",
					"application/x-www-form-urlencoded;"
				);
				request.onload = function () {
					if (this.status >= 200 && this.status < 400) {
						// If successful
						let response = this.response;
						let response_json = JSON.parse(response);
						if (response_json.success === true) {
							console.log(response_json.msg);
							document.querySelector('#single-pricing-form input[name="promo"]').classList.add('border-nelios-green-200');
							document.getElementById('promo-div-group').classList.remove('hidden');
							calcDiscount();
							document.getElementById('promo-div-group').dataset.discount = 'true';
						} else {
							document.getElementById('promo-div-group').classList.add('hidden');
							document.getElementById('promo-div-group').dataset.discount = 'false';
							calcDiscount();
						}
					} else {
						// If fail
						console.log("NO!");
					}
				};
				request.onerror = function () {
					// Connection error
				};
				let data = `action=${action}&nonce=${nonce}&promo=${e.target.value}`;
				request.send(data);
			})
			calcDiscount();
		}

		const components = new Components();
		components.init();
	},
};

/**
 * Remove `.no-js` from document body
 * when DOM has loaded.
 */
domReady(() => {
	document.body.classList.contains("no-js") &&
	document.body.classList.remove("no-js");
	App.init();

	// Start function to add custom controls for video
	function handleResize() {
		var videoHero = document.querySelector(".site-hero-video video");
		var videoMute = document.querySelector(".mute-bt");
		var playButton = document.querySelector(".play-bt");
		var pauseButton = document.querySelector(".pause-bt");

		if (videoHero && videoMute) {
			videoHero.removeAttribute('controls');
			videoHero.currentTime = 0;

			pauseButton.style.opacity = "0";

			videoMute.addEventListener("click", function() {
				if (videoHero.muted) {
					videoHero.muted = false;
					videoMute.classList.remove("stop");
				} else {
					videoHero.muted = true;
					videoMute.classList.add("stop");
				}
			});
			playButton.addEventListener("click", function() {
				playButton.style.display = "none";
				pauseButton.style.display = "block";
				pauseButton.style.opacity = "1";
				videoHero.play();
			});
			pauseButton.addEventListener("click", function() {
				playButton.style.display = "block";
				// playButton.style.opacity = "1";
				pauseButton.style.display = "none";
				pauseButton.classList.add("active");
				videoHero.pause();
			});
		}
	}

	window.addEventListener("resize", handleResize);
	handleResize();
	// End function to add custom controls for video

	const heroImage = document.querySelector('.hero-image');
	const videoPopup = document.querySelector('.popup-video');

	if (heroImage && videoPopup) {
		const playBtn = document.querySelector('.play-video-icon-wrapper');
		playBtn.addEventListener('click', ev => {
			const targetSelector = ev.target.getAttribute('data-target');
			const target = document.querySelector(targetSelector);
			const videoElement = target.querySelector('video');

			target.classList.add('active');
			videoElement.play();

			const closeButton = target.querySelector('.closing-x');
			closeButton.addEventListener('click', ev => {
				videoElement.pause();
				target.classList.remove('active');
			});
		});
	}

});
